var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('perseo_menu_mantenimientoVue',{attrs:{"config":{
      actualizar: {
        visible: true,
        habilitado: true,
        tieneApi: true
      },
      guardar: {
        visible: true,
        habilitado: false,
        tieneApi: false,
        tooltip: 'No disponible - Sin API configurada'
      },
      nuevo:{
        visible: true,
        habilitado: false,
        tieneApi: false,
        tooltip: 'No disponible - Sin API configurada'
      },
      modificar:{
        visible: true,
        habilitado: false,
        tieneApi: false,
        tooltip: 'No disponible - Sin API configurada'
      },
      eliminar:{
        visible: true,
        habilitado: false,
        tieneApi: false,
        tooltip: 'No disponible - Sin API configurada'
      },
      cancelar:{
        visible: true,
        habilitado: false,
        tieneApi: false,
        tooltip: 'No disponible - Sin API configurada'
      }  
    }}}),_c('div',{staticClass:"mt-4"},[_c('categoria_listadoVue')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }